module.exports = __webpack_public_path__ + "static/media/logo-mithikel.7f4f1f91.svg";